.report-holiday-table th,.report-holiday-table td{padding-top:.2rem;padding-bottom:.2rem;line-height:1.1}
/*# sourceMappingURL=report-holiday-list.component-NWSTVUNA.css.map */
